import { useState } from 'react';

export default function QuickStart() {
  const [copied, setCopied] = useState(false);
  
  const curlCommand = `curl -X POST https://api.quantra.io/price-vanilla-swap \\
  -H "X-API-Key: YOUR_KEY" \\
  -H "Content-Type: application/json" \\
  -d @request.json`;
  
  const copyCommand = async () => {
    try {
      await navigator.clipboard.writeText(curlCommand);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      console.error('Failed to copy');
    }
  };
  
  return (
    <div className="bg-white border border-[#e5e5e5] rounded-xl p-5">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-[#0a0a0a]">Quick Start</h3>
        <button
          onClick={copyCommand}
          className="text-xs text-[#737373] hover:text-[#0a0a0a] transition-colors"
        >
          {copied ? '✓ Copied' : 'Copy'}
        </button>
      </div>
      
      {/* Code block matching website style */}
      <div className="bg-[#171717] rounded-lg overflow-hidden">
        <div className="flex items-center gap-1.5 px-3 py-2 bg-[#262626]">
          <span className="w-2.5 h-2.5 rounded-full bg-[#ff5f56]"></span>
          <span className="w-2.5 h-2.5 rounded-full bg-[#ffbd2e]"></span>
          <span className="w-2.5 h-2.5 rounded-full bg-[#27ca40]"></span>
        </div>
        <pre className="text-xs font-mono text-[#d4d4d4] p-3 overflow-x-auto whitespace-pre-wrap">
          {curlCommand}
        </pre>
      </div>
      
      {/* Resources */}
      <div className="mt-4 pt-4 border-t border-[#e5e5e5]">
        <p className="text-xs text-[#a3a3a3] mb-2 uppercase tracking-wide font-medium">Resources</p>
        <div className="space-y-1.5">
          <a 
            href="https://github.com/joseprupi/quantraserver" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-sm text-[#525252] hover:text-[#0a0a0a] transition-colors"
          >
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
              <path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd" />
            </svg>
            GitHub Repository
          </a>
          <a 
            href="https://quantra.io" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-sm text-[#525252] hover:text-[#0a0a0a] transition-colors"
          >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
            </svg>
            quantra.io
          </a>
        </div>
      </div>
    </div>
  );
}
